import { CatalogServiceDto, ServiceType } from '@wix/bookings-uou-types';
import { ReferralInfo } from '../../utils/bi/consts';
import { NavigateToNextPageAction } from '../navigateToNextPage/navigateToNextPage';
import { OnBookFlowStartAttemptAction } from '../onBookFlowStartAttempt/onBookFlowStartAttempt';
import { WidgetViewModel } from '../../viewModel/viewModel';
import { setServiceLoader } from '../../utils/setServiceLoader/setServiceLoader';
import { NavigationTarget } from '../navigateToNextPage/consts';
import { flow } from 'lodash';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

export type OnActionButtonClickAction = ({
  service,
  referralInfo,
}: {
  service: CatalogServiceDto;
  referralInfo: ReferralInfo;
}) => Promise<void>;

export const createOnActionButtonClickAction = ({
  navigateToNextPage,
  onBookFlowStartAttempt,
  setProps,
  widgetViewModel,
  flowAPI,
}: {
  navigateToNextPage: NavigateToNextPageAction;
  onBookFlowStartAttempt: OnBookFlowStartAttemptAction;
  setProps: Function;
  widgetViewModel: WidgetViewModel;
  flowAPI: ControllerFlowAPI;
}): OnActionButtonClickAction => {
  return async ({
    service,
    referralInfo,
  }: {
    service: CatalogServiceDto;
    referralInfo: ReferralInfo;
  }) => {
    if (
      !flowAPI.experiments.enabled('specs.bookings.preCalculateShouldNavigate')
    ) {
      setServiceLoader({ setProps, widgetViewModel, service });
    }

    if (
      service.type === ServiceType.COURSE ||
      service.schedulePolicy.displayOnlyNoBookFlow
    ) {
      return navigateToNextPage({
        target: NavigationTarget.SERVICE_PAGE,
        service,
        referralInfo,
      });
    } else {
      return onBookFlowStartAttempt({ service, referralInfo });
    }
  };
};
